





























import { Component, Vue } from "vue-property-decorator";
import { Action, Mutation, Getter } from "vuex-class";
import { IImage } from "@/types/image";
import { IUser } from "@/types/user";

@Component({
  components: {}
})
export default class extends Vue {
  @Action("image/customerGetList")
  public getImageList!: (site_id: number) => boolean;
  @Getter("image/list")
  public images!: IImage[];
  @Getter("auth/me")
  public user!: IUser;

  @Mutation("image/clear")
  public clear!: () => void;

  public async created() {
    await this.getImageList(this.user.site_id);
  }
}
